import _objectWithoutProperties from "/Users/laurogripa/code/kusama/kappasigmamu.github.io/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["start", "end", "mid", "segments"];
import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';
import { Vector3, QuadraticBezierCurve3 } from 'three';
import mergeRefs from 'react-merge-refs';
import { Line } from './Line.js';
const v = new Vector3();
const QuadraticBezierLine = /*#__PURE__*/React.forwardRef(function QuadraticBezierLine(_ref, forwardref) {
  let {
      start = [0, 0, 0],
      end = [0, 0, 0],
      mid,
      segments = 20
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const ref = React.useRef(null);
  const [curve] = React.useState(() => new QuadraticBezierCurve3(undefined, undefined, undefined));
  const getPoints = React.useCallback(function (start, end, mid) {
    let segments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;
    if (start instanceof Vector3) curve.v0.copy(start);else curve.v0.set(...start);
    if (end instanceof Vector3) curve.v2.copy(end);else curve.v2.set(...end);
    if (mid instanceof Vector3) {
      curve.v1.copy(mid);
    } else {
      curve.v1.copy(curve.v0.clone().add(curve.v2.clone().sub(curve.v0)).add(v.set(0, curve.v0.y - curve.v2.y, 0)));
    }
    return curve.getPoints(segments);
  }, []);
  React.useLayoutEffect(() => {
    ref.current.setPoints = (start, end, mid) => {
      const points = getPoints(start, end, mid);
      if (ref.current.geometry) ref.current.geometry.setPositions(points.map(p => p.toArray()).flat());
    };
  }, []);
  const points = React.useMemo(() => getPoints(start, end, mid, segments), [start, end, mid, segments]);
  return /*#__PURE__*/React.createElement(Line, _extends({
    ref: mergeRefs([ref, forwardref]),
    points: points
  }, rest));
});
export { QuadraticBezierLine };